import { LOADING_STATUS } from "@/constants";
import userApi from '@/api/UserApi';
import { createSessionLoader } from '../../utils/session-loader';
import Vue from 'vue';
import { clearSearchStorage } from '../../utils/legacy-safety';
import dateFormat from '../../utils/dateformat';
import { sortBy, dayNicifier, getMonday } from '../../utils/helper';

const userReads = createSessionLoader(() => userApi.startUserRead());
function cacheAuthHint(isAuth) {
  try { window.localStorage.setItem('auth-data', JSON.stringify({ isAuth })); } catch (_) { /* Session truth comes from the API. */ }
}

export default {
  state: {
    user: null,
    loadUserError: null,
    currentProfile: {},
    profiles: [],
    profileData: null,
    userLoadingStatus: LOADING_STATUS.INITIAL,
    registrationLoadingStatus: LOADING_STATUS.INITIAL,
    saveProfileStatus: LOADING_STATUS.INITIAL,

    purchaseDayPicked: new Date(),
    purchaseRangePicked: {
      from: getMonday(new Date()),
      to: (getMonday(new Date())).setDate((getMonday(new Date())).getDate() + 6)
    },
    overload: 'range',
    getIdsToShow: [
      '21ffc672-02ca-411b-b210-97351f996512', // Баланс
      'ede8dfc0-6ef9-443b-bbf1-28aa6f67649b', // Пробное
      'e8bc1576-fdf5-494d-a90f-c31a43b8a21f', // Меню всей семьи
      'c8018c3f-f447-4a56-bc9a-6ca0f5b1ab78', // Десерты
      'a56a6ec7-11fe-4537-8e22-6b74d27b0580', // Вегетарианское меню
      '0d657f95-f393-42b3-8e6d-eea2c02322a5', // Боулы
      '1f9e97c4-5d42-4307-ac1c-daa360a047f0', // Хлеб и хлебцы
      'c7bf941e-7dac-4a41-9a2b-245870f7587a', // Ферментация
      '997b2e8f-13ba-4622-8f4f-b6f3e060083b', // Праздничное
      'b517544a-bcfe-4652-b06f-a4576afb8394', // Пробное меню всей семьи
      '0d95ba19-64c2-4210-93c6-fa6c19e73ac1', // Integra PNS
      '5a9e0d11-c055-44cc-b176-db2f61eab0b6', // Куличи и пасха
      // 'b520a267-631e-43b6-a10a-070cea48796d', // АИТ протокол
      // 'ec357f34-1bbb-4cca-a1b5-e2ebfc8bf0a1', // Школьное (old)
      // '600ebcd1-0cab-49d9-ad1f-a4a8fb994e0e', // Десерты (old)
      // '44cd9c91-cdd5-4f58-83c8-856a9961a018', // ???
    ]
  },

  getters: {
    getIdsToShow(state) {
      return state.getIdsToShow;
    },
    getOverload(state) {
      return state.overload;
    },
    getUserSettings(state) {
      if (!state.user) return {};
      if (!state.user.settings) return {}
      return JSON.parse(state.user.settings);
    },
    getPurchaseDayPicked(state) {
      return state.purchaseDayPicked || {};
    },
    getPurchaseRangePicked(state) {
      console.log('Maybe there', state.purchaseRangePicked)
      return state.purchaseRangePicked || {};
    },
    getUserSevenDaysLeft(state, getters) {
      if (!state.user) return true;
      if (getters.getUserSubscribes.length === 0) return true;

      const trialSubscribeId = 'ede8dfc0-6ef9-443b-bbf1-28aa6f67649b';
      const trialSubscribeExpiresAt = getters.getUserSubscribes.find(el => el.menu_id === trialSubscribeId)?.finished_at;
      const boughtedRegular = getters.getUserSubscribes.find(el => el.menu_id === '21ffc672-02ca-411b-b210-97351f996512' && el.is_paid === 't');
      const endDate = new Date(dayNicifier(trialSubscribeExpiresAt))

      if (new Date().getTime() > new Date(endDate).getTime() || boughtedRegular) return true;
      return false;
    },
    getActivityTypes(state) {
      return state.profileData?.references.activity_types || [];
    },
    getGoalTypes(state) {
      return state.profileData?.references.goal_types || [];
    },
    getUserLoadingStatus(state) {
      return state.userLoadingStatus;
    },
    getUser(state) {
      return state.user;
    },
    getProfiles(state) {
      return state.profiles;
    },
    getCurrentProfile(state) {
      return state.currentProfile;
    },
    getProfileGender(state) {
      return state.currentProfile?.gender;
    },
    getProfileBirthDate(state) {
      return state.currentProfile?.birth_date;
    },
    getProfileHeight(state) {
      return state.currentProfile?.height;
    },
    getProfileWeight(state) {
      return state.currentProfile?.weight;
    },
    getProfileActivity(state) {
      return state.currentProfile?.activity;
    },
    getProfileGoal(state) {
      return state.currentProfile?.goal;
    },
    getProfileAllergens(state) {
      return state.currentProfile?.allergens;
    },
    getLoadUserError(state) {
      return state.loadUserError;
    },
    getDifficultyReferences(state) {
      return state.profileData?.references?.recipe_difficulty || {};
    },
    getMealReferences(state) {
      return state.profileData?.references?.meal_types || {};
    },
    getUserFamily(state) {
      return state.profileData?.profiles || [];
    },
    getUserMenus(state) {
      return state.profileData?.menus || [];
    },
    getUserSets(state) {
      return state.profileData?.recipe_sets.filter(el => state.getIdsToShow.includes(el.recipe_set_id)) || []
    },
    getUserSubscribes(state) {
      return state.profileData?.subscriptions.filter(el => state.getIdsToShow.includes(el.menu_id)) || []
    },
    getAvaiableUserSets(state, getters) {
      const current = state.profileData?.references.recipe_sets;
      if (!current) return [];

      const recipeSets = sortBy(current, 'id', [
        'e8bc1576-fdf5-494d-a90f-c31a43b8a21f', // Меню для всей семьи
        'c8018c3f-f447-4a56-bc9a-6ca0f5b1ab78', // Десерты
        'a56a6ec7-11fe-4537-8e22-6b74d27b0580', // Вегетарианское меню
        '0d657f95-f393-42b3-8e6d-eea2c02322a5', // Боулы
        '1f9e97c4-5d42-4307-ac1c-daa360a047f0', // Хлеб и хлебцы
        'c7bf941e-7dac-4a41-9a2b-245870f7587a', // Ферментация
        '997b2e8f-13ba-4622-8f4f-b6f3e060083b', // Праздничное
        'b517544a-bcfe-4652-b06f-a4576afb8394', // Пробное меню всей семьи

        '0d95ba19-64c2-4210-93c6-fa6c19e73ac1', // Integra PNS

        '5a9e0d11-c055-44cc-b176-db2f61eab0b6', // Куличи и пасха
        'b520a267-631e-43b6-a10a-070cea48796d', // АИТ протокол
        'ec357f34-1bbb-4cca-a1b5-e2ebfc8bf0a1', // Школьное (old)
        '600ebcd1-0cab-49d9-ad1f-a4a8fb994e0e', // Десерты (old)
      ]);

      const boughtSets = recipeSets.filter((a) => !!getters.getUserSets.find(el => el.recipe_set_id === a.id));
      const notBoughtSets = recipeSets.filter((a) => !getters.getUserSets.find(el => el.recipe_set_id === a.id));

      return [...boughtSets, ...notBoughtSets].filter(el => state.getIdsToShow.includes(el.id))
    },
    getAvaiableUserSubscribes(state, getters) {
      const current = state.profileData?.references.menus;
      if (!current) return [];

      return sortBy(current, 'id', [
        '21ffc672-02ca-411b-b210-97351f996512', // Баланс
        'ede8dfc0-6ef9-443b-bbf1-28aa6f67649b', // Пробное
      ]).sort((a) => {
        return getters.getUserSubscribes.find(el => el.menu_id === a.id) ? -1 : 0
      }).filter(el => state.getIdsToShow.includes(el.id))
    }
  },

  mutations: {
    setOverload(state, overload) {
      state.overload = overload;
    },
    updateDayDate(state, day) {
      state.purchaseDayPicked = day;
    },
    updateRangeDate(state, date) {
      state.purchaseRangePicked = date;
    },
    setProfileSubscriptionMeal(state, payload) {
      const subscription = state.profileData.subscriptions.find(el => el.id === payload.subscription_id);
      if (!subscription) return;

      let currentMeal = subscription.profile_subscription_meals.find(el => el.profile_id === payload.profile_id);

      if (currentMeal) {
        currentMeal.meal_types = JSON.stringify(payload.meal_types)
      } else {
        subscription.profile_subscription_meals.push({
          ...payload,
          meal_types: JSON.stringify(payload.meal_types)
        })
      }
    },
    setUserLoadingStatus(state, status) {
      state.userLoadingStatus = status;
    },
    setUser(state, user) {
      state.user = user;
    },
    setCurrentProfile(state, profile) {
      state.currentProfile = profile;
    },
    setProfiles(state, profiles) {
      state.profiles = profiles;
    },
    addProfile(state, profile) {
      state.profiles.push(profile);
    },
    setProfileField(state, payload) {
      if(!state.currentProfile) {
        state.currentProfile = {};
      }
      for(let key in payload) {
        Vue.set(state.currentProfile, key, payload[key]);
      }
    },
    setLoadUserError(state, error) {
      state.loadUserError = error;
    },
    setProfileData(state, profileData) {
      state.profileData = profileData;
    },

    setSaveProfileStatus(state, status) {
      state.saveProfileStatus = status;
    },

    /**
     * Update concrete profile by ID
     * @param state
     * @param profileId String
     * @param profile
     */
    updateProfileById(state, { profileId, profile }) {

      for(let key in state.profiles) {
        if(state.profiles[key].id === profileId) {
          Vue.set(state.profiles, key, profile);
          return;
        }
      }
    },
    deleteProfileById(state, profileId) {
      for(let key in state.profiles) {
        if(state.profiles[key].id === profileId) {
          Vue.delete(state.profiles, key);
          return;
        }
      }
    }
  },

  actions: {
    async updateSettings({ state, commit }, payload) {
      let settings = {};

      // Поставить данные сразу
      for (let key in payload) {
        if (state.user && state.user.settings && state.user.settings[key]) {
          state.user.settings[key] = payload[key];
        }
      }

      if (state.user && state.user.settings) {
        settings = {
          ...JSON.parse(state.user.settings),
          ...payload,
        }
      } else {
        settings = payload;
      }

      const { data } = await userApi.updateUser({
        settings: JSON.stringify(settings),
      });

      commit('setUser', data.data.user);

    },
    // eslint-disable-next-line no-unused-vars
    async updateUser({ commit }, payload) {
      return await userApi.updateUser(payload);
    },
    invalidateUserLoad({commit}) {
      userReads.invalidate();
      commit('setUserLoadingStatus', LOADING_STATUS.INITIAL);
    },
    loadUser({commit}, options = {}) {
      return userReads.load({
        force: options.force === true,
        onStart() {
          commit('setLoadUserError', null);
          commit('setUserLoadingStatus', LOADING_STATUS.LOADING);
        },
        onSuccess(response) {
          if (response.data.success) {
            const data = response.data.data;
            commit('setProfileData', data);
            commit('setUser', data.user);
            commit('setCurrentProfile', {});
            const profiles = [];
            for (const profile of Object.values(data.profiles || {})) {
              if (profile.is_main === 't') commit('setCurrentProfile', profile);
              else profiles.push(profile);
            }
            commit('setProfiles', profiles);
            cacheAuthHint(true);
            commit('setUserLoadingStatus', LOADING_STATUS.SUCCESS);
          } else {
            if (response.data.error && response.data.error.auth_required) {
              commit('setUser', null);
              commit('setCurrentProfile', {});
              commit('setProfiles', []);
              commit('setProfileData', null);
              cacheAuthHint(false);
            }
            commit('setUserLoadingStatus', LOADING_STATUS.FAIL);
            commit('setLoadUserError', response.data.error || { unavailable: true });
          }
        },
        onFailure() {
          commit('setLoadUserError', { network: true });
          commit('setUserLoadingStatus', LOADING_STATUS.FAIL);
        },
      });
    },
    setProfileData({commit}, data) {
      commit('setProfileField', data);
    },
    logout({commit}) {
      try { clearSearchStorage(window.localStorage); } catch (_) { /* Optional storage. */ }
      userReads.invalidate();
      return userApi.logout().then(() => {
        commit('setUser', null);
        commit('setCurrentProfile', {});
        cacheAuthHint(false);
        commit('setProfiles', []);
        commit('setProfileData', null);
        commit('setLoadUserError', null);
        commit('setUserLoadingStatus', LOADING_STATUS.INITIAL);
      });
    },

    /**
     * Create profile for current user.
     * @TODO: refactor, only one createProfile method should exist.
     *
     * @param commit
     * @param state
     * @param dispatch
     * @param isMainProfile
     * @returns {Promise<T | never>}
     */
    createProfile({ commit, state, dispatch }, isMainProfile) {
      let profile = {
        ...state.currentProfile,
      };

      if(isMainProfile) {
        profile.is_main = 't';
        profile.name = profile.title = state.user.name;
        delete profile.title;
      } else {
        profile.is_main = 'f';
      }

      if (profile.birth_date) {
        const splitDate = profile.birth_date.split('.');
        profile.birth_date = dateFormat(new Date(splitDate[2], splitDate[1] - 1, splitDate[0]), 'yyyy-mm-dd');
      }

      return userApi.saveProfile(profile)
        .then(({data}) => {
          if(data.success) {
            commit('setCurrentProfile', data.data.profile);
            dispatch('loadUser', { force: true });
          } else {
            console.error('Error while creating the profile: %o', data.data);
          }
          return data;
        });
    },

    /**
     * Create new profile and return the profile entity created.
     *
     * @param commit
     * @param profile
     * @returns {Promise<T | never>}
     */
    async createNewProfile({ state, commit, dispatch }, profile) {
      if (state.saveProfileStatus === LOADING_STATUS.LOADING) return { success: false };
      commit('setSaveProfileStatus', LOADING_STATUS.LOADING);
      const payload = { ...profile, is_main: 'f' };
      delete payload.title;
      try {
        const { data } = await userApi.saveProfile(payload);
        if (data.success) {
          commit('addProfile', data.data.profile);
          commit('setSaveProfileStatus', LOADING_STATUS.SUCCESS);
          await dispatch('loadUser', { force: true });
        } else {
          commit('setSaveProfileStatus', LOADING_STATUS.FAIL);
        }
        return data;
      } catch (error) {
        commit('setSaveProfileStatus', LOADING_STATUS.FAIL);
        throw error;
      }
    },

    /**
     * Upload profile avatar and return updated profile entity.
     *
     * @param commit
     * @param profileId
     * @param avatar
     * @param isCurrentProfile
     */
    async uploadAvatar({commit, dispatch}, {profileId, avatar, isCurrentProfile}) {
      commit('setSaveProfileStatus', LOADING_STATUS.LOADING);
      try {
        const { data } = await userApi.uploadAvatar(profileId, avatar);
        if (data.success === false || !data.id || !data.avatar_url) throw new Error('AvatarUploadFailed');
        if (isCurrentProfile) commit('setCurrentProfile', data);
        else commit('updateProfileById', {profileId, profile: data});
        commit('setSaveProfileStatus', LOADING_STATUS.SUCCESS);
        await dispatch('loadUser', { force: true });
        return true;
      } catch (error) {
        commit('setSaveProfileStatus', LOADING_STATUS.FAIL);
        return false;
      }
    },
    updateProfile({ commit, dispatch }, profile) {
      commit('setSaveProfileStatus', LOADING_STATUS.LOADING);
      let profileToSave = Object.assign({}, profile);
      return userApi.updateProfile(profileToSave).then(({ data }) => {
        if(data.success) {
          commit('setSaveProfileStatus', LOADING_STATUS.SUCCESS);
          commit('updateProfileById', { profileId: data.data.profile.id, profile: data.data.profile });
          dispatch('loadUser', { force: true })
        } else {
          commit('setSaveProfileStatus', LOADING_STATUS.FAIL);
        }
        return data;
      }).catch((error) => {
        console.error('Error during save the profile: %o', error);
        commit('setSaveProfileStatus', LOADING_STATUS.FAIL);
        return error;
      })
    },

    /**
     * Delete profile.
     *
     * @param commit
     * @param profileId
     * @returns {Promise<T | never>}
     */
    deleteProfile({ commit }, profileId) {
      return userApi.deleteProfile(profileId).then(({data}) => {
        if(data.success) {
          commit('deleteProfileById', profileId);
        }
      });
    }
  }
};
